import { Directive } from '@angular/core';
import { AbstractModalOpenDirective } from '@df/ui/modal/abstract-modal-open.directive';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { CheckoutMinibasketModalComponent } from './checkout-minibasket-modal.component';

@Directive({
    selector: '[checkoutMinibasketModalOpen]',
    standalone: true
})
export class CheckoutMinibasketModalOpenDirective extends AbstractModalOpenDirective<CheckoutMinibasketModalComponent> {
    component = CheckoutMinibasketModalComponent;

    /** Close modal on navigation change */
    override readonly closeOnNavigation = true;

    /** Modal position */
    override readonly modalPosition = 'bottom';

    override readonly modalConfig: ModalConfig = {
        minWidth: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        modalClass: 'bg-col-w p-a-0'
    };
}
